import TEMPLATE_URL from "emun.order/add-multi-orders.htm";
import controller from "emun.order/add-multi-orders.controller";
import open from "webmodals/open";

export default ({
	size = "xl",
	backdrop = "static",
	placement = "center",
	templateUrl = TEMPLATE_URL,
	mode = "multi-add",
	imageSize = "xxs",
	criteria = {},
	product = {},
	updateItems = false,
	httpMethod = "GET",
	title = `Add to Orders...`,
	subTitle,
}) =>
	open({
		size,
		backdrop,
		templateUrl,
		placement,
		controller,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			title: () => title,
			subTitle: () => subTitle,
			mode: () => mode,
			imageSize: () => imageSize,
			httpMethod: () => httpMethod,
			criteria: () => criteria,
			product: () => product,
			updateItems: () => updateItems,
		},
	}).result;
